import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../../../../context/AuthContext";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const errorText = (err) => err.response?.data?.message || err.message || "Bir hata oluştu";

const Row = ({ label, children }) => (
    <tr>
        <th className="fw-semibold text-nowrap" style={{ width: "30%" }}>{label}</th>
        <td className="text-break">{children || <span className="text-danger">Tanımlı değil</span>}</td>
    </tr>
);

const Defined = ({ value }) => (
    <span className={`badge ${value ? "bg-success" : "bg-danger"}`}>{value ? "Tanımlı" : "Tanımlı değil"}</span>
);

// Salt okunur: değerler .NET API'nin appsettings.json dosyasındaki PaytrSettings bölümünden gelir.
export const AdminPaytrIntegration = () => {
    const { user } = useAuth();
    const [status, setStatus] = useState(null);
    const [loadError, setLoadError] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/admin/Setting/GetPaytrStatus`, {
                    headers: { Authorization: `Bearer ${user?.token}` },
                });
                if (res.data.success) setStatus(res.data.data);
                else setLoadError(res.data.message || "PayTR bilgileri alınamadı.");
            } catch (err) {
                setLoadError(errorText(err));
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loadError) {
        return <div className="py-4"><div className="alert alert-danger">{loadError}</div></div>;
    }

    if (!status) {
        return <div className="py-4 text-center text-muted">Yükleniyor...</div>;
    }

    const isTest = status.testMode === "1";
    const ready = status.merchantId && status.hasMerchantKey && status.hasMerchantSalt;

    return (
        <div className="py-4">
            <div className="card shadow-sm border-0 mb-4 p-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <div>
                        <h3 className="fw-bold text-primary m-0">PayTR</h3>
                        <small className="text-muted">Kredi kartı ödeme bilgileri</small>
                    </div>
                    <div className="d-flex gap-2">
                        <span className={`badge fs-6 ${ready ? "bg-success" : "bg-danger"}`}>{ready ? "Ayarlı" : "Eksik"}</span>
                        <span className={`badge fs-6 ${isTest ? "bg-warning text-dark" : "bg-primary"}`}>{isTest ? "Test modu" : "Canlı mod"}</span>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <table className="table align-middle mb-3">
                        <tbody>
                            <Row label="Mağaza No">{status.merchantId}</Row>
                            <Row label="Mağaza Parolası (key)"><Defined value={status.hasMerchantKey} /></Row>
                            <Row label="Mağaza Gizli Anahtarı (salt)"><Defined value={status.hasMerchantSalt} /></Row>
                            <Row label="Başarılı ödeme adresi">{status.okUrl}</Row>
                            <Row label="Başarısız ödeme adresi">{status.failUrl}</Row>
                            <Row label="Bildirim adresi"><code>{API_BASE_URL}/Paytr/Callback</code></Row>
                        </tbody>
                    </table>
                    <div className="small text-muted">
                        PayTR mağaza panelindeki Bildirim URL bu adresle aynı olmalı; aksi halde ödemeler otomatik onaylanmaz.
                        Bu bilgiler .NET API'nin <code>appsettings.json</code> dosyasından okunur, bu ekrandan değiştirilemez.
                        Anahtar değerleri güvenlik nedeniyle gösterilmez.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPaytrIntegration;
